/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import Slideout from 'components/transition/Slideout';
import SlideoutContent from 'components/slideout/SlideoutContent';
import VisTypeChooser from './VisTypeChooser';
import StringResources from 'nls/StringResources';

import _ from 'underscore';

class VisTypeChooser_Slideout extends Component {

	render() {
		const forwardedProps = _.omit(this.props, 'active', 'className', 'onClose');

		return (
			<Slideout
				active={this.props.active}
				className={this.props.className}
				fullHeight={true}
				onClickOutside={this.props.onClose}
			>
				<SlideoutContent
					title={StringResources.get('choose_visualization_type')}
					onClose={() => this._handleOnCloseClick()}
				>
					<VisTypeChooser {...forwardedProps} />
				</SlideoutContent>
			</Slideout>
		);
	}

	_handleOnCloseClick() {
		this.props && this.props.onClose && this.props.onClose();
	}
}

VisTypeChooser_Slideout.propTypes = {
	active: PropTypes.bool,
	className: PropTypes.string,
	onClose: PropTypes.func
};

export default VisTypeChooser_Slideout;



// WEBPACK FOOTER //
// ./src/js/components/visTypeChooser/index.js